import { Box } from "@mui/material";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import Form from "@accredo/fe-shared/components/Form/Form.jsx";
import SubmitButton from "@accredo/fe-shared/components/Form/controls/SubmitButton.jsx";
import FormTextField from "../../../components/Form/controls/FormTextField.jsx";
import { useInsurerActions } from "../../../hooks/useInsurerActions.jsx";
import { useInsurerPermissions } from "../../../hooks/permissions/useInsurerPermissions.jsx";

const validationSchema = yup.object({
  max_mail_size_mb: yup
    .number()
    .typeError("Bitte eine Zahl eingeben")
    .positive("Muss größer als 0 sein")
    .nullable(),
});

/**
 * Maximum mail size of an insurer.
 */
export default function InsurerSettingsForm({ insurer, onSaved }) {
  const { canUpdateEmail } = useInsurerPermissions();
  const { updateMaxMailSize } = useInsurerActions();
  const canEdit = canUpdateEmail(insurer);

  return (
    <Form
      defaultValues={{
        max_mail_size_mb: insurer.max_mail_size
          ? Math.round((insurer.max_mail_size / (1024 * 1024)) * 100) / 100
          : null,
      }}
      onSubmit={async (formData) => {
        try {
          await updateMaxMailSize(insurer.id, {
            max_mail_size: formData.max_mail_size_mb
              ? Math.round(formData.max_mail_size_mb * 1024 * 1024)
              : null,
          });
          onSaved?.();
          return true;
        } catch (error) {
          console.error("Error updating insurer:", error);
          return false;
        }
      }}
      resolver={yupResolver(validationSchema)}
    >
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 480 }}
      >
        <FormTextField
          name="max_mail_size_mb"
          label="Maximale Mailgröße (MB)"
          helperText="Optional. Wenn leer, gilt der Standard-Grenzwert."
          type="number"
          fullWidth
          disabled={!canEdit}
        />
        {canEdit && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <SubmitButton variant="primary">Speichern</SubmitButton>
          </Box>
        )}
      </Box>
    </Form>
  );
}

InsurerSettingsForm.propTypes = {
  insurer: PropTypes.object.isRequired,
  onSaved: PropTypes.func,
};
